import TrovaServizioPage from "./TrovaServizioPage";
import { TROVA_OSPITI_CONFIG } from "../components/trova/servizioConfigs";

export default function TrovaOspiti() {
  return <TrovaServizioPage config={TROVA_OSPITI_CONFIG} />;
}
